import Node from "./node";
import Connection from '@/components/whiteboard/connection';

export default class Layer {
    name;
    project;
    nodes;
    connections;

    constructor(name, project) {
        if (typeof name === 'object') {
            this.load(name, project);
        } else {
            this.init(name, project);
        }
    }

    init(name, project) {
        this.name = name;
        this.project = project;
        this.nodes = [];
        this.connections = [];
    }

    load(json, project) {
        this.init(json.name, project);

        for (let i = 0; i < json.nodes.length; i++) {
            new Node(this, json.nodes[i]);
        }

        for (let i = 0; i < json.connections.length; i++) {
            new Connection(this, json.connections[i]);
        }
    }


    deactivate() {
        for (let i = 0; i < this.nodes.length; i++) {
            this.nodes[i].hide();
        }

        for (let i = 0; i < this.connections.length; i++) {
            this.connections[i].hide();
        }
    }

    activate() {
        this.project.activeLayer = this;

        for (let i = 0; i < this.nodes.length; i++) {
            this.nodes[i].show();
        }

        for (let i = 0; i < this.connections.length; i++) {
            this.connections[i].show();
        }
    }

    toSerializable() {
        let o = {
            name: this.name,
            nodes: [],
            connections: [],
        };

        for (let i = 0; i < this.nodes.length; i++) {
            o.nodes.push(this.nodes[i].toSerializable());
        }

        for (let i = 0; i < this.connections.length; i++) {
            o.connections.push(this.connections[i].toSerializable());
        }

        return o;
    }

    destroy() {
        for (let i = 0; i < this.nodes.length; i++) {
            this.nodes[i].destroy();
        }

        for (let i = 0; i < this.connections.length; i++) {
            this.connections[i].destroy();
        }
    }
}
